<template>
    <v-expansion-panel
        v-model="panel"
        expand
    >
        <v-expansion-panel-content
            :key="'expansion-' + parentKey"
        >
            <v-layout
                row wrap pb-3 pt-0 style="padding: 0 10px"
                v-if="waitFetchCross || data.status === 'waiting'"
            >
                <div class="cross-loading-hint">
                    <v-progress-circular
                        indeterminate
                        size="18"
                        width="2"
                        color="#00BA57"
                    />
                    <transition name="fade-loading" mode="out-in">
                        <span :key="loadingText">
                            {{ loadingText }}
                        </span>
                    </transition>
                </div>
            </v-layout>
            <v-layout
                row wrap pb-3 pt-0 style="padding: 0 10px"
                v-else-if="data.status !== 'error'"
            >
                <v-tabs :grow="true"
                        slider-color="#000"
                        v-model="tab"
                >
                    <v-tab
                        v-for="(category, key) in parsedCrosses"
                        :key="key"
                        :style="{ '--delay': (key * 0.8) + 's' }"
                    >
                        {{ category.name }}
                    </v-tab>
                </v-tabs>
            </v-layout>
            <v-layout
                v-if="waitFetchCross || data.status === 'waiting'"
                class="cross-items"
                row wrap pb-4
            >
                <v-flex
                    class="cross-item loading"
                    xs12 sm5 md3 lg3
                >
                    <v-layout row wrap>
                        <v-flex lg12>
                            <div class="cross-item__top">
                                <div class="cross-item__top__left">
                                    <span class="cross-item__title skeleton-text">Загрузка продукта…</span>
                                    <span class="cross-item__subtitle skeleton-text">Подбор страховой программы</span>
                                </div>
                                <div class="cross-item__top__right">
                                    <div class="skeleton-logo skeleton-green"></div>
                                </div>
                            </div>
                            <v-layout>
                                <v-flex class="cross-item__price-block shrink block-first">
                                    <span class="cross-item__price skeleton-text">СП, ₽</span>
                                    <span class="skeleton-line skeleton-green w-100"></span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-second">
                                    <span class="skeleton-text">|</span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-center">
                                    <span class="cross-item__price skeleton-text">КВ, %</span>
                                    <span class="skeleton-line skeleton-green w-100"></span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-second">
                                    <span class="skeleton-text">|</span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-third">
                                    <span class="cross-item__price skeleton-text">КВ, ₽</span>
                                    <span class="skeleton-line skeleton-green w-100"></span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex lg12 class="pt-0">
                            <span class="cross_item__date-start skeleton-text">Начало действия — рассчитываем…</span>
                        </v-flex>
                        <v-flex lg12 class="pt-0">
                            <div class="cross-item__buttons loading">
                                <span class="btn-skeleton skeleton-green"></span>
                                <span class="btn-skeleton skeleton-green"></span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout
                v-else-if="data.status !== 'error'"
                v-show="selectedCategoryProducts"
                class="cross-items"
                row wrap pb-4
            >
                <v-flex
                    class="cross-item"
                    xs12 sm5 md3 lg3
                    v-for="(item, index) in selectedCategoryProducts"
                    :key="item.id"
                    :class="{ 'active': selectedCrossId === item.id }"
                    @click="selectItem(item)"
                >
                    <v-layout row wrap>
                        <v-flex lg12>
                            <div class="cross-item__top">
                                <div class="cross-item__top__left">
                                    <span class="cross-item__title" v-if="item.companyName">{{ item.companyName }}</span>
                                    <span class="cross-item__subtitle my-tippy" data-tippy-animateFill="false"
                                          data-tippy-animation="scale"
                                          :data-tippy-content="item.name">{{ item.name }}</span>
                                </div>
                                <div class="cross-item__top__right" v-if="item.companyLogotype">
                                    <img class="cross-item__logo" :src="getImageUrl(item.companyLogotype)" alt="" />
                                </div>
                            </div>
                            <v-layout>
                                <v-flex class="cross-item__price-block shrink block-first">
                                    <span class="cross-item__price">СП</span>
                                    <span class="cross-item__price">{{ item.price + ' ₽' }}</span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-second">
                                    <span>|</span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-center" @click.prevent.stop="hideCrossCommissions" v-if="!commissionsHidden">
                                    <span class="cross-item__price">КВ, %</span>
                                    <span class="cross-item__price" v-if="!crossCommissionsHidden">{{ getCommissionPercent(item) ? getCommissionPercent(item) + ' %' : '-' }}</span>
                                    <span v-else>Вернуть</span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-second">
                                    <span>|</span>
                                </v-flex>
                                <v-flex class="cross-item__price-block shrink block-third" @click.prevent.stop="hideCrossCommissions" v-if="!commissionsHidden">
                                    <span class="cross-item__price">КВ, ₽</span>
                                    <span class="cross-item__price" v-if="!crossCommissionsHidden">{{ item.commission + ' ₽' }}</span>
                                    <span v-else>Вернуть</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
<!--                        <v-flex lg3 v-if="selectedCompanyLogotype">
                            <img class="cross-item__logo" :src="getImageUrl(selectedCompanyLogotype)" alt="" />
                        </v-flex>-->
                        <v-flex lg12 class="pt-0" v-if="item && item.dateStart">
                            <span class="cross_item__date-start">Начало действия с {{ moment(item.dateStart).format('DD.MM.YYYY') }}</span>
                        </v-flex>
                        <v-flex lg12 class="pt-0">
                            <div class="cross-item__buttons">
                                <v-menu
                                    offset-x
                                    :position-x="0"
                                    :position-y="0"
                                    transition="scale-transition"
                                    bottom
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on }">
                                        <a
                                            color="white"
                                            light
                                            v-on="on"
                                            :class="'p-0'"
                                            @click.stop
                                        >
                                            <span class="cross-item__more">Подробнее</span>
                                        </a>
                                    </template>
                                    <v-card min-width="300">
                                        <div
                                            class="info-row"
                                            v-for="(info, index) in item.info" :key="index"
                                        >
                                            <div class="info-left" :style="info.title.includes('Ущерб ТС при условиях') ? 'white-space:pre' : ''">
                                                <span v-html="formatTitle(info.title)"></span>
                                            </div>
                                            <div class="info-right" :style="info.title.includes('Ущерб ТС при условиях') ? 'white-space:pre; padding-left: 16px' : ''">
                                            <span :class="getColorClass(info.notice)">
                                                <span v-html="formatValue(info.value)"></span>
                                            </span>
                                            </div>
                                        </div>
                                        <div class="docs-info" v-if="selectedCategoryName.toLowerCase() === 'авто-нс'">
                                            <p>Информационный блок: "Оплачивая Полис страхования подтверждаю, что
                                                ознакомлен и согласен с условиями:"</p>
                                            <div class="docs-info__list">
                                                <a
                                                    :href="item.link"
                                                    v-for="(item, index) in docsList"
                                                    :key="index"
                                                    target="_blank"
                                                >
                                                    {{ '- ' + item.name }}
                                                </a>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-menu>
                                <a v-if="(data && !data.is_required_cross && data.cross_payed_id == null && selectedCrossId === item.id) || (!data && selectedCrossId === item.id)">
                                    <span class="cross-item__more">Отменить выбор</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-form v-if="waitFetchCross || data.status === 'waiting'">

            </v-form>
            <v-form ref="approve" class="approve-form" v-else-if="shouldShowApproveForm && data.status !== 'error'">
                <v-layout row wrap class="align-center">
                    <v-flex shrink class="text-center">
                        <v-btn
                            @click="approve('button')"
                            class="payButton"
                            :loading="paymentLoading"
                            :disabled="!crossApproved || !selectedCrossId || data.cross_payed_id !== null"
                            :id="data.alias + '_osago_cross'"
                        >
                            {{ data.cross_payed_id ? 'Оформлен' : 'Оформить' }}
                        </v-btn>
                        <a
                            v-if="data.cross_payed_id == null"
                            @click="selectedCrossId ? approve('link') : ''"
                            :class="['block mt-3', selectedCrossId && crossApproved ? 'payLink' : 'disabledLink']"
                        >
                            Оплатить по ссылке
                        </a>
                    </v-flex>
                    <v-flex>
                        <v-checkbox
                            v-model="crossApproved"
                            :rules="[rules.approveCross]"
                            validate-on-blur
                            :disabled="!selectedCrossId || data.cross_payed_id !== null"
                        >
                            <template v-slot:label>
                                <div class="policy-wrapper" v-if="selectedCategoryName.toLowerCase() === 'авто-нс'">
                                    КВ за кросс начисляется только к оплаченным ОСАГО.<br>
                                    На 1 ОСАГО — 1 добровольный КРОСС. Подтверждаю условия и<br>
                                    принимаю правила раздела "Подробнее"
                                </div>
                                <div class="policy-wrapper" v-else>
                                    КВ за кросс начисляется только к оплаченным ОСАГО.<br>
                                    На 1 ОСАГО — 1 добровольный КРОСС. Подтверждаю условия.
                                </div>
                            </template>
                        </v-checkbox>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import moment from "moment";

export default {
    name: "OsagoCompaniesListCross",
    props: [
        'data',
        'parentKey',
        'panel',
        'crosses',
        'selectedCrossId',
        'commissionsHidden',
        'crossCommissionsHidden',
        'updatedAt',
        'orderStatus',
        'waitFetchCross',
    ],
    data: () => ({
        tabItems: [],
        productArrays: [],
        tab: 0,
        personalTab: 0,
        isActive: false,
        parsedCrosses: {},
        paymentLoading: false,
        hashId: null,
        crossApproved: false,
        docsList: [
            {
                name: 'Полис-оферта',
                link: '/docs/avto-ns/polis-oferta-avto-ns(sample).pdf',
            },
            {
                name: 'Ключевой информационный документ',
                link: '/docs/avto-ns/kid-avto-ns.pdf',
            },
            {
                name: 'Правила страхования',
                link: '/docs/avto-ns/nsib-rules.pdf',
            },
            {
                name: 'Согласие на обработку персоннальных данных',
                link: '/docs/avto-ns/personal-data-processing-avto-ns.pdf',
            },
        ],
        loadingMessages: [
            'Подбираем кросс-продукты…',
            'Обычно это занимает не больше минуты'
        ],
        loadingIndex: 0,
        loadingTimer: null,
        rules: {
            approveCross: v => v || 'Необходимо подтвердить утверждение',
        },
    }),
    methods: {
        downloadLink(link) {
            return window.location.origin + link
        },
        selectItem(item) {
            if (this.data.cross_payed_id == null) {
                this.$emit('selectCrossId', this.data.id, item, this.selectedCategoryKey);
            }
        },
        getColorClass(notice) {
            if (notice === true) {
                return 'true-value';
            } else if (notice === false) {
                return '';
            }
            return '';
        },
        getImageUrl(img) {
            return window.location.origin + '/' + img;
        },
        formatTitle(text) {
            try {
                const parsedText = JSON.parse(`"${text}"`);
                return parsedText.replace(/\n/g, '<br>');
            } catch (error) {
                return text.toString();
            }
        },
        formatValue(crossInfoValue) {
            if (typeof crossInfoValue === 'boolean') {
                return crossInfoValue ? 'Да' : 'Нет';
            }
            return this.formatTitle(crossInfoValue);
        },
        approve(type) {
            if (this.$refs.approve.validate()) {
                this.crossButtonPay(type);
            } else {
                this.$nextTick(function() {
                    PNotify.error('Проверьте правильность выделенных полей.')
                });
            }
        },
        crossButtonPay(type) {
            this.paymentLoading = true;
            this.$emit('crossSaleClick');
            if (type === 'button') {
                axios.post(`/cross-pay/${this.hashId}/${this.selectedCrossId}`)
                    .then(response => {
                        if (response.data) {
                            const paymentLink = response.data;
                            window.open(paymentLink, '_blank');
                        }
                    })
                    .catch(error => {
                        this.paymentLoading = false;
                        if (error.response && error.response.data && error.response.data.message) {
                            PNotify.error(error.response.data.message);
                        }
                    })
                    .finally(() => {
                        this.paymentLoading = false;
                    });
            } else {
                window.open(`/manage-cross/${this.hashId}/${this.selectedCrossId}`, '_blank');
                this.paymentLoading = false;
            }
        },
        hideCrossCommissions() {
            this.$emit('hideCrossCommissions');
        },
        safeParse(raw) {
            if (!raw) return null;
            try {
                return JSON.parse(raw);
            } catch (e) {
                console.error('Ошибка парсинга crosses:', e, raw);
                return null;
            }
        },
        sortCompaniesFirst(crossesArr) {
            crossesArr.sort((a, b) => {
                if (a.companyName === 'Альфа Страхование') return -1;
                if (b.companyName === 'Альфа Страхование') return 1;
                return 0;
            });
        },
        groupByCategory(crossesArr) {
            const grouped = {};
            crossesArr.forEach(category => {
                const catName = (category.name && category.name.trim()) ? category.name.trim() : 'Без категории';
                if (!grouped[catName]) grouped[catName] = { name: catName, products: [] };


                const products = Array.isArray(category.products)
                    ? category.products
                    : (category.products ? [category.products] : []);
                const productsWithMeta = products.map(prod => ({ ...prod, companyName: category.companyName, companyLogotype: category.companyLogotype }));
                grouped[catName].products.push(...productsWithMeta);
            });
            return Object.values(grouped);
        },
        parseCrosses(source) {
            if (!source) {
                this.parsedCrosses = [];
                this.tabItems = [];
                this.productArrays = [];
                return;
            }

            const parsed = this.safeParse(source);
            if (!parsed) {
                this.parsedCrosses = [];
                return;
            }

            const rawCrosses = parsed.crosses ? parsed.crosses : parsed;
            let crossesArray = Array.isArray(rawCrosses)
                ? rawCrosses
                : Object.values(rawCrosses);

            if (!Array.isArray(crossesArray)) {
                this.parsedCrosses = [];
                return;
            }

            /*this.sortCompaniesFirst(crossesArray);*/

            let merged = this.groupByCategory(crossesArray);

            merged.forEach(cat => {
                if (Array.isArray(cat.products)) {
                    cat.products.sort((a, b) => (a.price || 0) - (b.price || 0));
                }
            });

            merged.sort((a, b) => {
                if (a.name === 'Авто-НС') return -1;
                if (b.name === 'Авто-НС') return 1;
                return 0;
            });

            this.parsedCrosses = merged;
            this.tabItems = merged.map(c => c.name);
            this.productArrays = merged.map(cat => ({ category: cat.name, products: cat.products }));

            if (this.data && this.selectedCategoryProducts && this.selectedCategoryProducts.length > 0) {
                this.$nextTick(() => {
                    this.selectItem(this.selectedCategoryProducts[0]);
                })
            }

            if (this.data && this.data.cross_payed_id && this.selectedProducts) {
                let product = this.selectedProducts.find(function (product) {
                    return product.id == this.data.cross_payed_id;
                }.bind(this));
                if (product) {
                    this.$nextTick(() => {
                        this.$emit('selectCrossId', this.data.id, product, this.selectedCategoryKey);
                    })
                }
            }

            if (this.data && this.data.payment && this.data.payment.manageLink) {
                let regex = /\/([^\/]+)$/;
                let match = this.data.payment.manageLink.match(regex);
                if (match) {
                    this.hashId = match[1];
                }
            }
        },
        getCommissionPercent(item) {
            if (item && item.price && item.commission) {
                const price = Number(item.price);
                const commission = Number(item.commission);

                if (!price || price <= 0 || isNaN(price)) {
                    return false;
                }

                if (!commission || isNaN(commission)) {
                    return false;
                }

                const percent = (commission / price) * 100;

                if (!percent || isNaN(percent)) {
                    return false;
                }

                return Math.round(percent * 100) / 100;
            }
        },
        initLoadingText() {
            if (this.loadingTimer) return;
            this.loadingIndex = 0;
            this.loadingTimer = setInterval(() => {
                this.loadingIndex =
                    (this.loadingIndex + 1) % this.loadingMessages.length;
            }, 5000);

        },
        clearLoadingText() {
            if (this.loadingTimer) {
                clearInterval(this.loadingTimer);
                this.loadingTimer = null;
            }
            this.loadingIndex = 0;
        },
    },
    created() {
        this.parseCrosses(this.crosses || (this.data && this.data.crosses));
        this.initLoadingText();
    },

    computed: {
        moment() {
            return moment
        },
        selectedProducts() {
            if (this.parsedCrosses && Object.keys(this.parsedCrosses).length > 0) {
                return Object.keys(this.parsedCrosses).reduce((products, key) => {
                    return products.concat(this.parsedCrosses[key].products);
                }, []);
            }
        },
        selectedCategoryProducts() {
            if (this.parsedCrosses && Object.keys(this.parsedCrosses).length > 0) {
                if (this.parsedCrosses[this.selectedCategoryKey]) {
                    return this.parsedCrosses[this.selectedCategoryKey].products;
                } else {
                    return [];
                }
            }
        },
        selectedCategoryKey() {
            if (this.parsedCrosses && Object.keys(this.parsedCrosses).length > 0) {
                const keys = Object.keys(this.parsedCrosses);
                return keys[this.tab] || keys[0];
            }
        },
        selectedCategoryName() {
            if (this.parsedCrosses && Object.keys(this.parsedCrosses).length > 0) {
                if (this.parsedCrosses[this.selectedCategoryKey]) {
                    return this.parsedCrosses[this.selectedCategoryKey].name;
                } else {
                    return '';
                }
            }
        },
        shouldShowApproveForm() {
            // Если статус не 'success' — всегда показывать
            if (this.orderStatus !== 'success') return true;

            if (!this.updatedAt) return true;

            const updatedDateParts = this.updatedAt.split(' в ')[0].split('.');

            const updatedDate = new Date(
                `${updatedDateParts[2]}-${updatedDateParts[1]}-${updatedDateParts[0]}`
            );

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return today <= updatedDate;
        },
        loadingText() {
            return this.loadingMessages[this.loadingIndex];
        },
    },
    watch: {
        crosses: {
            handler(newVal) { this.parseCrosses(newVal || (this.data && this.data.crosses)); },
            immediate: true,
            deep: true,
        },
        'data.crosses': {
            handler(newVal) {
                this.parseCrosses(newVal || this.crosses);
            },
            immediate: true,
            deep: true,
        },
        'data.payment': {
            handler() {
                if (this.data && this.data.payment && this.data.payment.manageLink) {
                    const regex = /\/([^\/]+)$/;
                    this.hashId = this.data.payment.manageLink.match(regex)[1];
                }
            },
            deep: true,
        },
        tab: {
            handler() {
                this.selectItem(this.selectedCategoryProducts[0]);
            },
        },
        waitFetchCross(val) {
            if (val) {
                this.initLoadingText();
            } else {
                this.clearLoadingText();
            }
        },
    },
    updated: () => {
        window.tippy.default('.my-tippy');
    },
}
</script>

<style scoped lang="scss">
.v-expansion-panel {
    box-shadow: none;
}

/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    animation: blink-green 2s linear infinite;
    -moz-animation: blink-green 2s linear infinite;
    -webkit-animation: blink-green 2s linear infinite;
    animation-delay: var(--delay, 0s);
}

/deep/ .v-tabs__item:not(.v-tabs__item--active) {
    opacity: 1;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
    animation: none;
}

@keyframes blink-green {
    0% { color: #00ba57; }
    100% { color: black; }
}


.cross-items {
    padding: 0 10px;
    gap: 12px;
}

.cross-item {
    border: 1px solid #E8E8E8;
    border-radius: 8px;
    opacity: 0.6;
    padding: 6px !important;
}

.active {
    outline: 2px solid #00BA57;
    opacity: 1;
}

.cross-item:hover {
    outline: 2px solid #00BA57;
    cursor: pointer;
    opacity: 1;
}

.cross-item.loading:hover {
    outline: unset;
    cursor: unset;
    opacity: unset;
}

.cross-item__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.cross-item__top__left {
    overflow: hidden;
    white-space: nowrap;
}

.cross-item__top__right {
    max-width: 60px;
}

.cross-item__title {
    font-size: 13px;
    display: block;
}

.cross_item__date-start {
    font-family: SFPro,sans-serif;
    font-size: 12px;
    line-height: 1.5;
    color: #00ba57;
}

.cross-item__buttons {
    display: flex;
    justify-content: space-between;
}

.cross-item__more {
    font-size: 14px;
    border-bottom: 1px solid #00BA57;
    user-select: none;
}

.cross-item__subtitle {
    display: block;
    color: #828282;
    font-size: 12px;
    font-family: 'SFUIDisplay';
    text-overflow: ellipsis;
    overflow: hidden;
}

.cross-item__price-block {
    display: flex;
    flex-direction: column;
}

.block-first {
    padding-right: 0 !important;
}

.block-second {
    align-self: end;
    padding: 10px 6px !important;
}

.block-center {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.block-third {
    padding-left: 0 !important;
}

.cross-item__price {
    font-size: 14px;
    font-weight: 700;
}

.cross-item__logo {
    max-width: 100px;
    width: 100%;
}

.cross-item:active {
    outline: 2px solid #00BA57;
    opacity: 1;
}

.info-row {
    display: flex;
    justify-content: space-between;
    padding: 6px 12px;
    border-bottom: 1px solid #ccc;
    align-items: center;
}

.info-left {
    font-size: 12px;
    flex: 1;
}

.info-right {
    font-size: 12px;
    flex: 1;
    text-align: right;
}

.policy-wrapper {
    font-size: 12px;
    line-height: 1.4;
}

.true-value {
    color: #00ba57;
}

.false-value {
    color: #ff5252;
}

.payButton {
    color: #ffffff !important;
    line-height: 1.55 !important;
    font-weight: 400 !important;
    font-size: 15px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 44px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: block;
    vertical-align: middle;
    padding: 0 52px;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.payButton >>> .v-btn__content {
    white-space: normal;
    line-height: 1.1;
}

.payLink {
    color: #00ba57;
    text-decoration: underline;
}

.disabledLink {
    cursor: default;
    color: rgba(0, 0, 0, 0.26);
    text-decoration: underline;
}

.text-center {
    text-align: center;
}

.block {
    display: block;
}

.docs-info {
    padding: 6px 12px;

    p {
        font-size: 12px;
        margin-bottom: 8px;
    }

    &__list {
        display: flex;
        flex-direction: column;
        gap: 8px;

        a {
            font-size: 12px;
            text-decoration: unset;
            width: fit-content;
        }
    }
}

/* ===== SKELETON BASE ===== */

.skeleton-logo {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: linear-gradient(
            90deg,
            #e6e6e6 25%,
            #f2f2f2 37%,
            #e6e6e6 63%
    );
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
    display: inline-block;
}

.skeleton-line {
    height: 14px;
    border-radius: 6px;
    background: linear-gradient(
            90deg,
            #e6e6e6 25%,
            #f2f2f2 37%,
            #e6e6e6 63%
    );
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
    display: inline-block;
}


.skeleton-green {
    background: linear-gradient(
            90deg,
            rgba(0,186,87,0.12) 25%,
            rgba(0,186,87,0.22) 37%,
            rgba(0,186,87,0.12) 63%
    );
    background-size: 400% 100%;
}

@keyframes skeleton-loading {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: -100% 0;
    }
}

.skeleton-text {
    color: #bdbdbd;
    font-weight: 400;
}

.btn-skeleton {
    width: 90px;
    height: 26px;
    border-radius: 6px;
}

.cross-item.loading {
    position: relative;
    overflow: hidden;
    opacity: 1;
}

.cross-item.loading::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 2px;

    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0,186,87,0.4);

    background: linear-gradient(
            90deg,
            transparent 0%,
            transparent 40%,
            #00BA57 50%,
            transparent 60%,
            transparent 100%
    );

    background-size: 300% 300%;

    animation: border-run 3.2s linear infinite;

    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);

    -webkit-mask-composite: xor;
    mask-composite: exclude;

    pointer-events: none;
}

@keyframes border-run {
    0% {
        background-position: 0% 50%;
    }

    100% {
        background-position: 300% 50%;
    }
}

.cross-loading-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #00BA57;
    font-size: 13px;
    font-weight: 500;
}

.cross-item__buttons.loading {
    opacity: 0.7;
    pointer-events: none;
}

.fade-loading-enter-active,
.fade-loading-leave-active {
    transition: opacity .4s ease, transform .4s ease;
}

.fade-loading-enter {
    opacity: 0;
    transform: translateY(4px);
}

.fade-loading-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}

@media (max-width: 600px) {
    .cross-items {
        flex-wrap: wrap;
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/components/elements/OsagoCompaniesListCross.vue